import { useEffect } from "react";
import { useLocation } from "react-router-dom";
const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        const timeout = setTimeout(() => {
            // Pages with their own hash navigation can handle it after rendering.
            if (hash && pathname === "/privacy-policy") return;
            window.scrollTo({ top: 0, behavior: "instant" });
        }, 100);
        return () => clearTimeout(timeout);
    }, [pathname, hash]);
    return null;
};
export default ScrollToTop;
